import { addMonths } from "date-fns";
import * as yup from "yup";
import { nonEmptyArray } from "./utils";

export const DATE_FORMAT = "MMM dd yyyy, hh:mm a";

export const PAGINATION_OPTIONS = [10, 25, 50, 100, "All"];
export const DEFAULT_PAGINATION = PAGINATION_OPTIONS[1];

export const VALIDATION_SCHEMA = yup.object({
  timestep: yup.string().required("Time Step is required"),
  basins: nonEmptyArray("Basins are required"),
  dataSources: nonEmptyArray("Data sources are required"),
  organizations: nonEmptyArray("Organizations are required"),
  parameterGroups: nonEmptyArray("Parameter groups are required"),
  locationTypes: nonEmptyArray("Location types are required"),
  parameters: nonEmptyArray("Parameters are required"),
  locations: nonEmptyArray("Locations are required"),
  startDate: yup.date().required("Start date is required"),
  endDate: yup.date().required("End date is required"),
  dataCategory: yup.number().integer().nullable(true),
});

export const DEFAULT_VALUES = {
  timestep: "",
  basins: [],
  dataSources: [],
  organizations: [],
  parameterGroups: [],
  locationTypes: [],
  parameters: [],
  locations: [],
  startDate: addMonths(new Date(), -3),
  endDate: new Date(),
  dataCategory: null,
};

export const USE_QUERY_OPTIONS = {
  keepPreviousData: false,
  refetchOnWindowFocus: false,
  staleTime: Infinity,
  cacheTime: Infinity,
};

export const FILENAME = `UpperYampaWaterConservancyDistrictData-${new Date()}.csv`;
